import React from 'react';
import GlyphSvg from './Glyphs';

const WorkflowControls = ({
  serverStatus,
  availableWorkflows,
  selectedWorkflow,
  selectedFile,
  isRunning,
  progress,
  progressPercentage,
  executionProgress,
  hasWebSocketProgress,
  wsConnected,
  wsConnectionStatus,
  queueInfo,
  onWorkflowSelect,
  onRunWorkflow,
  onClearWorkflow,
  onRequestQueueInfo
}) => {
  const getWebSocketStatusText = () => {
    switch (wsConnectionStatus) {
      case 'connecting':
        return 'Connecting...';
      case 'connected':
        return 'Connected';
      case 'comfyui_connected':
        return 'Connected';
      case 'comfyui_disconnected':
        return 'Disconnected';
      case 'error':
        return 'Error';
      default:
        return 'Disconnected';
    }
  };

  const getWebSocketStatusClass = () => {
    switch (wsConnectionStatus) {
      case 'comfyui_connected':
        return 'connected';
      case 'connected':
        return 'connecting';
      case 'comfyui_disconnected':
      case 'error':
        return 'disconnected';
      default:
        return 'disconnected';
    }
  };

  return (
    <div className="controls-area">
      {/* Server Status */}
      <div className="status-section">
        <div className="status-indicator">
          <div className={`status-dot ${serverStatus === 'connected' ? 'connected' : 'disconnected'}`}></div>
          <span className="status-text">
            <strong>Server:</strong> {serverStatus === 'connected' ? 'Connected' : 
             serverStatus === 'checking' ? 'Checking...' : 'Disconnected'}
          </span>
        </div>
        
        {/* WebSocket Status */}
        <div className="status-indicator">
          <div className={`status-dot ${getWebSocketStatusClass()}`}></div>
          <span className="status-text">
            <strong>WS:</strong> {getWebSocketStatusText()}
          </span>
        </div>
      </div>

      {/* Tool Selection */}
      <div className="workflow-section">
        <select 
          value={selectedWorkflow || ''} 
          onChange={(e) => onWorkflowSelect(e.target.value)}
          disabled={!availableWorkflows.length}
        >
          <option value="">Select a tool...</option>
          {availableWorkflows.map((workflow, index) => (
            <option key={index} value={workflow}>
              {workflow.replace('.json', '')}
            </option>
          ))}
        </select>
      </div>

      {/* Progress Display */}
      <div className="progress-section">
        <div className="progress-container">
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${progressPercentage}%` }}
            ></div>
            <div className="progress-text">
              {progress || 'No progress yet...'}
            </div>
          </div>
        </div>
        
        {executionProgress && (
          <div className="execution-details">
            {executionProgress.currentNode && (
              <div className="execution-node">
                Current: {executionProgress.currentNode}
              </div>
            )}
            {executionProgress.currentStep > 0 && executionProgress.totalSteps > 0 && (
              <div className="execution-steps">
                Step: {executionProgress.currentStep}/{executionProgress.totalSteps}
              </div>
            )}
            {executionProgress.rate && (
              <div className="execution-rate">
                Rate: {executionProgress.rate.toFixed(2)} it/s
              </div>
            )}
          </div>
        )}
      </div>

      {/* Action Buttons */}
      <div className="action-buttons">
        <button 
          onClick={onRunWorkflow}
          disabled={!selectedWorkflow}
          className="run-btn"
          title={isRunning ? "Add to queue" : "Run tool"}
        >
          <GlyphSvg name="play" />
          {isRunning ? 'Queue' : 'Run'}
        </button>
        
        <button 
          onClick={onClearWorkflow}
          disabled={!selectedWorkflow}
          className="clear-btn"
          title="Clear tool"
        >
          ✕ Clear
        </button>
      </div>
      
      {/* Queue Status Indicator - After both buttons */}
      <div className="queue-status-indicator">
        <div className="queue-dot"></div>
        <span>Current queue: {queueInfo.queue_remaining || 0}</span>
      </div>
    </div>
  );
};

export default WorkflowControls;

